export default {
  lang: 'en',
  messages: {
    'app.title': 'MMP',
    'header.center.title': 'MRD MANAGEMENT PLATFORM',
    'app.copyright': '© {copyrightYear} International Post Corporation',
    'app.signIn': 'sign in',
    'app.signOut': 'sign out',
    'message.notFound': '404: Page not found',
    'button.login': 'Login',
    'error.unexpected_error': 'Unexpected Error',
    'Request failed with status code 400': 'The username and/or password is incorrect . Please try again. If the problem persists please contact the IPC Help Desk at helpdesk@ipc.be.',
    'app.user.role.accessDenied': 'Connected user is not authorized to perform this action.',
    'notification.denestimpcmapping.add.success': 'New mapping successfully added',
    'notification.denestimpcmapping.add.failure': 'Failure',
    'notification.denestimpcmapping.deactivate.failure': 'Failure',
    'notification.denestimpcmapping.deactivate.success': 'Changes successfully saved',
    'notification.mrd.edit.success': 'Device is edited successfully',
    'notification.mrd.edit.failure': 'Failure',
    'notification.mrd.add.success': 'Device is added successfully',
    'notification.mrd.add.failure': 'Failure',
    'notification.flight.delete.active.success': 'The flight will be removed from the list by the end of the day',
    'notification.flight.delete.future.success': 'The flight removed from the list successfully',
    'flight.delete.active.label': 'Are you sure you want to delete this Flight record? The flight will be removed from the MRD flight list by the end of the day',
    'flight.delete.future.label': 'Are you sure you want to delete this Flight record? This record will be immediately removed from the MRD flight list',
    'flight.add.edit.validation.validTo.after.today': 'Valid to should be after current date.',
    'flight.add.edit.validation.validTo.after.validFrom': 'Valid to should be after valid from.',
    'impcmapping.deactive.unsaved.changes.warning.message': 'There are records which have not been saved. All changes will be lost. Do you wish to leave this page?',
    'impcmapping.deactive.future.records.info.message': 'Selected future records will be deleted.',
    'device.information.mac.address.validation.message': 'This is not a valid MAC address. Valid example = AA-11-BB-22-CC-33',
    'device.information.mac.address.unique.validation.message': 'MAC address should be unique',
    'device.information.mrd.name.unique.validation.message': 'MRD name should be unique',
    'notification.flights.add.success': 'Flight added successfully',
    'notification.mrd.associate.handler.success': 'Selected handlers are associated to the Device',
    'notification.mrd.associate.handler.failure': 'Failure',
    'notification.flights.edit.success': 'Flight edited successfully',
    'notification.handlers.copy.success': 'Device settings have been copied',
    'notification.contacts.add.success': 'New contact have been added',
    'notification.contacts.add.failure': 'New contact addition has failed',
    'notification.threshold.add.success': 'New threshold have been added',
    'notification.threshold.add.failure': 'New threshold addition has failed',
    'notification.contacts.edit.success': 'Contact edited successfully',
    'notification.contacts.edit.failure': 'Contact edit request failed',
    'notification.contacts.copy.success': 'Contacts have been copied',
    'notification.contacts.associate.success': 'Contact have been associated',
    'notification.contacts.delete.success': 'Contact deleted successfully',
    'notification.threshold.delete.success': 'Threshold deleted successfully',
    'notification.threshold.edit.success': 'Thresholds edited successfully',
    'notification.handlers.edit.success': 'Handler edited successfully',
    'notification.mrd.handler.failure': 'Failure',
    'notification.handlers.associate.success': 'New Handler successfully associated',
    'notification.handlers.associate.failure': 'New Handler association has failed',
    'notification.mrd.settings.edit.success': 'Device Settings are edited successfully',
    'notification.mrd.settings.edit.failure': 'Failure',
    'notification.translations.edit.failure': 'Translations edit has been failed',
    'notification.translations.edit.success': 'Changes saved successfully',
    'filter-component.label.equals': 'Equals',
    'filter-component.label.greater-than': 'Greater than',
    'filter-component.label.greater-than-equal-to': 'Greater than or equal to',
    'filter-component.label.smaller-than': 'Smaller than',
    'filter-component.label.smaller-than-equal-to': 'Smaller than or equal to',
    'filter-component.label.between': 'Between',
    'filter-component.label.contains': 'Contains',
    'filter-component.label.starts-with': 'Starts with',
    'filter-component.action.apply': 'Apply',
    'filter-component.action.clear-filter': 'Clear',
    'filter-component.action.cancel': 'Cancel',
    'filter-component.action.filter': 'Filter',
    'contact.ipc.delete.active.label': 'All IMPC and Data location associations of this contact will be deleted. Are you sure you want to delete this Contact?',
    'contact.mrd.delete.active.label': 'Are you sure you want to delete this Contact?',
    'contact.xml.delete.active.label': 'Are you sure you want to delete this Contact?',
    'threshold.delete.active.label': ' Are you sure you want to delete this threshold?',
    'contact.edit.existing.ipc.label': 'Do you wish to edit existing contact?',
    'contact.edit.existing.operator.label': 'Do you wish to add existing contact to the viewed contact list?',
    'contact.edit.operator.admin.info.message': 'IMPC location field allows you only to add new locations.',
    'translations.edit.unsaved.changes': 'There might be changes which have not been saved. All changes will be lost. Do you wish to leave this page?',
  },
};
